module.exports = __webpack_public_path__ + "media/buy_report_icons/basic_information-4d04a401.svg";